import {
  filter_all,
  filter_last_30_days,
  filter_last_month,
  filter_last_week,
  filter_this_month,
  filter_this_week,
  filter_today,
  filter_yesterday,
} from '../../../../../components/filters/DateRangePicker';

export default {
  filters: {
    [filter_today]: 'Vandaag',
    [filter_yesterday]: 'Gisteren',
    [filter_this_week]: 'Deze week',
    [filter_last_week]: 'Vorige week',
    [filter_this_month]: 'Deze maand',
    [filter_last_month]: 'Vorige maand',
    [filter_last_30_days]: 'Laatste 30 dagen',
    [filter_all]: 'Alles',
  },
};
